import { Component, Input, OnInit } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/utils/pipes/safe-html.pipe';

@Component({
  selector: 'app-atendimento-card',
  standalone: true,
  imports: [
    SafeHtmlPipe
  ],
  templateUrl: './atendimento-card.component.html',
  styleUrl: './atendimento-card.component.css'
})
export class AtendimentoCardComponent implements OnInit {
  @Input() Title!: string;
  @Input() Icons!: string[];
  @Input() SideBorder = "right";
  @Input() Emphasis = '';
  @Input() Topic?: string;
  @Input() IconPosition = "center";
  @Input() CustomStyleBody = "";
  @Input() CustomStyleCard = "";

  protected EmphasisStyle!: string;
  protected SideBorderClass!: string;
  protected IconPositionClass!: string;

  ngOnInit(): void {
    this.SideBorderClass =
      this.SideBorder == 'right' ?
        'row sub-atendimento-card border-right' :
      this.SideBorder == 'all' ?
        'row sub-atendimento-card border-all-around' :
        'row sub-atendimento-card border-left'

    this.EmphasisStyle =
      this.Emphasis == EnumEmphasis.WithEmphasis ?
          'color-emphasis' :
        this.Emphasis == EnumEmphasis.LessEmphasis ?
          'color-less-emphasis' :
          ''

    this.IconPositionClass =
      this.IconPosition == "center" ?
        'icon-on-center color-emphasis col-1' :
        'icon-3rem-below color-emphasis col-1'
  }
}

export enum EnumEmphasis {
  WithEmphasis = 'w',
  LessEmphasis = 'l'
}
